import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["video"]

  connect() {
    this.boundPauseVideo = this.pauseVideo.bind(this)
    document.addEventListener("turbo:before-cache", this.boundPauseVideo)
    document.addEventListener("turbo:before-visit", this.boundPauseVideo)
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.boundPauseVideo)
    document.removeEventListener("turbo:before-visit", this.boundPauseVideo)
    this.pauseVideo()
  }

  pauseVideo() {
    if (this.hasVideoTarget) {
      this.videoTarget.pause()
      this.videoTarget.src = ""
      this.videoTarget.load()
    }
  }
}
